<template>
  <article class="message is-success">
    <div class="message-header">
      <p>{{ $texts('redeemVoucher', 'Gutschein einlösen') }}</p>
    </div>
    <div class="message-body">
      <div class="mb-4" v-html="text" />
    </div>
  </article>
</template>

<script setup lang="ts">
defineProps<{
  text: string
}>()
const { $texts } = useNuxtApp()
</script>
